<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">방제사전관리 상세</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>방제상품코드</span></th>
                  <td>{{dictinaryInfo.dictionary_cd}}</td>
                </tr>
                <tr>
                  <th><span>방제명</span></th>
                  <td>{{dictinaryInfo.dictionary_nm}}</td>
                </tr>
                <tr>
                  <th><span>한자명</span></th>
                  <td>{{dictinaryInfo.dictionary_chinese_nm}}</td>
                </tr>
                <tr>
                  <th><span>출전</span></th>
                  <td>{{dictinaryInfo.dictionary_source}}</td>
                </tr>                
                <tr>
                  <th><span>사용여부</span></th>
                  <td>{{dictinaryInfo.use_yn}}</td>
                </tr>        
                <tr>
                  <th><span>처방설명</span></th>
                  <td>{{dictinaryInfo.dictionary_note1}}</td>
                </tr>                           
                <tr>
                  <th><span>참고사항</span></th>
                  <td>{{dictinaryInfo.dictionary_note2}} </td>
                </tr>                           
                <tr>
                  <th>약재명</th>
                  <td>
                    <div class="table_list">
                      <table class="list no_view">
                        <colgroup>
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                        </colgroup>
                        <thead>
                            <th>약재명</th>
                            <th>이명</th>
                            <th>설명</th>
                            <th>용량</th>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in dictinaryHerbInfo" :key="index">
                            <td><span>{{ item.med_hrb_nm }}</span></td>
                            <td><span>{{ item.med_alias }}</span></td>
                            <td><span>{{ item.med_prfm }}</span></td>
                            <td>
                              <span>{{ item.med_use_qnty }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>        
                <!-- <tr>
                  <th><span>약재비</span></th>
                  <td>{{totalPrice}}원</td>
                </tr>                           -->
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_list_page">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_gray" @click="fn_del_dictionary(dictinaryInfo.dictionary_cd)">삭제</button>
                <button class="btn btn_md btn_darkblue" @click="fn_mod_dictionary(dictinaryInfo.dictionary_cd)">수정</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  

  export default {
    name: 'DictionaryMngtDtl',
    components: {
    },
    data() {
      return {
        selected: null,
        dictionaryCd : '',
        dictinaryInfo : {},
        dictinaryHerbInfo : [],
        totalPrice : 0
      }
    },
    created(){
        this.dictionaryCd = this.$store.getters['dictionary/getDictionaryCd']
        console.log("@@@@ getDictionaryCd : "+this.dictionaryCd);

        this.fn_search(this.dictionaryCd);
    },
    methods : {
       fn_search(dictionaryCd){

            let param = new Object();
            param.dictionaryCd = dictionaryCd;

            console.log("@@@@ param : %o",param);

            axios
                .post("/api/admin/dictionary/getDictionaryDetail", param)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.dictinaryInfo = res.data.dictionaryInfo;
                    this.dictinaryHerbInfo = res.data.dictionaryHerbList;
                    console.log("@@@@ dictinaryInfo : %o",this.dictinaryInfo);
                    console.log("@@@@ dictinaryHerbInfo : %o",this.dictinaryHerbInfo);

                    //this.fn_get_totalPrice();
                })
                .catch((err) => console.log(err));
                
        },
        fn_get_totalPrice(){
            let totalPrice = 0;
            for( let i = 0; i < this.dictinaryHerbInfo.length ; i++){
                let price = this.dictinaryHerbInfo[i].med_sale_prc;
                let useQy = this.dictinaryHerbInfo[i].med_use_qnty;

                //javascript 소수점 오류 처리
                let countPrice = totalPrice + Number((price * useQy).toFixed(2))
                totalPrice = Number(countPrice.toFixed(2));
            }

            this.totalPrice = totalPrice;
        },
        fn_move_list_page(){
            this.$store.dispatch('dictionary/setStatus', ''); 
            this.$router.push("/admin/dictionary/DictionaryMngt");
        },
        fn_del_dictionary(dictionaryCd){
            let param = new Object();
            param.dictionaryCd = dictionaryCd;

            axios
                .post("/api/admin/dictionary/deleteDictionary", param)
                .then((res) => {
                    alert("삭제되었습니다");
                    this.fn_move_page();                        
                })
                .catch((err) => console.log(err));
        },
        fn_mod_dictionary(dictionaryCd){
            this.$store.dispatch('dictionary/setDictionaryCd', dictionaryCd);
            this.$store.dispatch('dictionary/setStatus', 'M'); 

            this.$router.push("/admin/dictionary/dictionaryMngtReg");
        },
        fn_move_page(){
            this.$router.push("/admin/dictionary/dictionaryMngt");
        }, 
    }
  }
</script>